import slots from './pageSlots.json';

/**
 * The sections of each built-in page, in the order they were designed in.
 *
 * Kept as JSON because it is read from two sides that share no code: the
 * application, which renders the sections, and scripts/generate-cms-config.js,
 * which turns the same list into the choices an editor sees - where an added
 * section goes, and in which order the page's own sections run.
 *
 * This module is the typed way in. Nothing else should import the JSON.
 */

export interface PageSlot {
  /** The name the page component and the content files use. */
  key: string;
  /** What an editor sees in the editing interface. */
  label: string;
}

/** The pages that are built in code, as opposed to assembled in the CMS. */
export type BuiltInPage = keyof typeof slots;

export const PAGE_SLOTS: Record<BuiltInPage, PageSlot[]> = slots;

/**
 * The sections an editor may reorder: every one except the first.
 *
 * The first slot is the top of the page, and it is not a section the page
 * renders from this list - it is the start page's hero, the title band of the
 * pages that have one, or simply the position above everything on the pages
 * that have neither. It is offered as a place to put an added section and
 * nowhere else, so nothing can be dragged above the page's own opening.
 */
export const orderableSlots = (page: BuiltInPage): string[] =>
  PAGE_SLOTS[page].slice(1).map((slot) => slot.key);
